const { getElement, getElements } = window.BAO.Utils

let dropdownLoaded = false

class HeaderDropdown extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (dropdownLoaded) return

    this.isDesktopMode = window.BAO.MediaBreakpoints.isMd

    if (!this.isDesktopMode) return

    window.BAO.sectionRenderer
      .fetch('header', `${window.Shopify.routes.root}?view=dropdown`)
      .then((res) => {
        dropdownLoaded = true

        const newDOM = window.BAO.sectionRenderer.convertToDOM(res.header)
        const myself = newDOM.querySelector(this.localName)

        this.outerHTML = myself.outerHTML
      })
      .catch(() => {})
  }

  setupListeners () {
    super.setupListeners()

    this.onViewportChange = this.onViewportChange.bind(this)
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.VIEWPORT.CHANGE,
      this.onViewportChange,
    )

    if (!this.isDesktopMode) return

    this.initDesktopListeners()
  }

  initDesktopListeners () {
    if (
      document.querySelector('[data-header-dropdown-el="menu-dropdown-toggle"]')
    ) {
      document.addEventListener(
        'click',
        this.handleToggleButtonClick.bind(this),
      )
    }

    document.addEventListener('focusin', this.handleFocusIn.bind(this))

    document.addEventListener('keyup', this.handleEscapePress.bind(this))
  }

  onViewportChange ({ detail }) {
    const newIsDesktop =
      detail.currentBreakpoint !== 'xxs' && detail.currentBreakpoint !== 'xs'

    if (newIsDesktop && !this.isDesktopMode) {
      this.isDesktopMode = true

      if (!dropdownLoaded) {
        this.connectedCallback()
      }
    } else if (!newIsDesktop && this.isDesktopMode) {
      this.isDesktopMode = false
      this.closeDropdowns()
    }
  }

  /**
   * @param {ClickEvent} event
   *
   * @returns {void}
   */
  handleToggleButtonClick (event) {
    if (
      !event.target.closest('[data-header-dropdown-el="menu-dropdown-toggle"]')
    ) {
      return
    }

    const menuToggleEl = event.target
    const parentItemEl = menuToggleEl.closest(this.els?.item?.selector)
    if (!parentItemEl) return
    const menuDropdownEl = getElement(this.els?.['menu-dropdown']?.selector, {
      context: parentItemEl,
    })

    if (!menuDropdownEl) return

    const isExpanded = menuDropdownEl.getAttribute('aria-expanded') === 'true'

    if (isExpanded) {
      menuToggleEl.removeAttribute('data-active')
      menuDropdownEl.removeAttribute('aria-expanded')
    } else {
      menuToggleEl.setAttribute('data-active', String(!isExpanded))
      menuDropdownEl.setAttribute('aria-expanded', String(!isExpanded))
    }
  }

  /**
   * @param {FocusInEvent} event
   *
   * @returns {void}
   */
  handleFocusIn (event) {
    if (
      event.target.closest(this.localName) &&
      !event.target.closest('[aria-expanded="true"]')
    ) {
      /* This ensures an expanded dropdown closes when the user tabs out of it but focus remains within the header-dropdown element */
      this.closeDropdowns()
    }

    if (!event.target.closest(this.localName)) {
      /* This ensures all dropdowns are closed when focus leaves the header-dropdown element */
      this.closeDropdowns()
    }
  }

  /**
   * @param {KeyboardEvent} event
   *
   * @returns {void}
   */
  handleEscapePress (event) {
    if (event.code?.toUpperCase() !== 'ESCAPE') return
    this.closeDropdowns()
  }

  /**
   * @returns {void}
   */
  closeDropdowns () {
    getElements('[data-header-dropdown-el="menu-dropdown-toggle"]').forEach(
      (menuDropdownEl) => {
        menuDropdownEl.removeAttribute('data-active')
      },
    )

    getElements('[data-header-dropdown-el="menu-dropdown"]').forEach(
      (menuDropdownEl) => {
        menuDropdownEl.removeAttribute('aria-expanded')
      },
    )
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    window.BAO.eventBus.removeEventListener(
      window.BAO.EVENTS.VIEWPORT.CHANGE,
      this.onViewportChange,
    )
  }
}

if (!customElements.get('header-dropdown')) {
  customElements.define('header-dropdown', HeaderDropdown)
}
